const hasAddresses = (addresses) => {
  const format = address => `${address.address}, ${address.city}, ${address.state} ${address.zipCode}`;
  return {
    getAddressesWithAdded(address) {
      if (!addresses.length) {
        return [{ ...address, isDefault: true }];
      }
      return [{ ...address, isDefault: false }, ...addresses];
    },
    getAddressesWithDefault(defaultIndex) {
      return addresses.map((address, index) => {
        if (index === defaultIndex) {
          return { ...address, isDefault: true };
        }
        return { ...address, isDefault: false };
      });
    },
    getAddressesWithDeleted(index) {
      const withDeleted = [...addresses];
      withDeleted.splice(index, 1);
      return withDeleted;
    },
    getAddressesWithUpdated(index, address) {
      const withUpdated = [...addresses];
      withUpdated.splice(index, 1, address);
      return withUpdated;
    },
    getDefaultAddress() {
      const index = addresses.findIndex(address => address.isDefault);
      return format(addresses[index]);
    },
    getFormattedAddresses() {
      return addresses.map((address) => {
        const formatted = {
          label: address.label,
          address: format(address),
        };
        if (address.isDefault) {
          formatted.isDefault = true;
        }
        return formatted;
      });
    },
  };
};

export default hasAddresses;
